import { useLayoutContext } from 'contexts/LayoutContext';
import React from 'react';
import { useParams } from 'react-router-dom';
import CreateReversalPage from './CreateReversalPage';
import ViewReversalPage from './ViewReversalPage';
import FormWrapper from './FormWrapper';

const ReversalPageWrapper: React.FC<{ mode: 'create' | 'view' }> = ({
  mode,
}) => {
  const { selectedVehicleId } = useLayoutContext();
  const { actionId: groupId } = useParams<{ actionId: string }>();

  if (!selectedVehicleId || !groupId) {
    return null;
  }

  if (mode === 'view') {
    return <ViewReversalPage vehicleId={selectedVehicleId} />;
  }

  return (
    <FormWrapper groupId={groupId}>
      <CreateReversalPage vehicleId={selectedVehicleId} />
    </FormWrapper>
  );
};

export const CreateReversal: React.FC = () => (
  <ReversalPageWrapper mode="create" />
);
export const ViewReversal: React.FC = () => <ReversalPageWrapper mode="view" />;

export default ReversalPageWrapper;
